import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { errorLogger } from '../../../common/utils/errorLogger'
import { AppDispatch, RootState } from '../../../store'
import { AxiosError, AxiosResponse } from 'axios'
import { RequestFailureMessage } from '../../../common/utils/messagesContants'
import { LoadingTypes, startLoading, stopLoading } from '@labrav/common'

import { camelize } from 'casing'
import { AwsAccountIDs } from './reducer'
import { fetchWAFRAWSAccounts } from '../../api/cloudfaas/wafr'

export enum WAFRCreateAssessmentForm {
  ADD_AWS_ACCOUNT_IDS = 'ADD_AWS_ACCOUNT_IDS',
}

export const setAWSAccountIDs = (payload: AwsAccountIDs[]) => ({
  type: WAFRCreateAssessmentForm.ADD_AWS_ACCOUNT_IDS,
  payload,
})

export const getAWSAccountIDs =
  (partnerId: string) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      const response = await fetchWAFRAWSAccounts(partnerId)
      if (response?.data) {
        const awsAccountIDsResponse = camelize(response?.data)

        await dispatch(
          setAWSAccountIDs(awsAccountIDsResponse as AwsAccountIDs[])
        )
      }
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }
